import { render, staticRenderFns } from "./declareSearch.vue?vue&type=template&id=d677e30e&scoped=true"
import script from "./declareSearch.vue?vue&type=script&lang=js"
export * from "./declareSearch.vue?vue&type=script&lang=js"
import style0 from "./declareSearch.vue?vue&type=style&index=0&id=d677e30e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d677e30e",
  null
  
)

export default component.exports